import React from 'react';
import './aboutus.css'; // Optional: Add custom styles in a CSS file

function CodeOfEthics() {
  const ethicsPoints = [
    { title: "RESPECT", content: "The right, dignity, and autonomy of the patients." },
    { title: "ADVISE", content: "Patients referral to another optometrist or other health professional when necessary." },
    { title: "ENSURE", content: "Confidentiality and privacy of patients' protected health and personal information." },
    { title: "STRIVE", content: "To ensure that all persons have access to eye and vision care." },
    { title: "ADVANCE", content: "Professional knowledge and proficiency to maintain and expand competence to benefit their patients." },
    { title: "PRACTICE", content: "With conscience and integrity to enhance the profession's status and promote public confidence." },
    { title: "RECOGNIZE", content: "Their obligation to protect the health and welfare of society." },
    { title: "CONDUCT", content: "Themselves as exemplary citizens and professionals with honesty, integrity, fairness, kindness, and compassion." }
  ];

  return (
    <div className="code-of-ethics">
      <h1>Code of Ethics</h1>
      <ul>
        {ethicsPoints.map((point, index) => (
          <li key={index} className="ethics-point">
            <h2>{point.title}</h2>
            <p>{point.content}</p>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default CodeOfEthics;
